import type { RouteRecordRaw } from 'vue-router';

/**
 * Two flat routes rather than a nested master-detail like the inbox.
 *
 * The inbox nests because an agent works *inside* it — the list, its filters
 * and its scroll position have to survive switching threads. The directory is
 * something you pass through on the way to one publisher, and keeping the list
 * mounted behind a full card would cost a column of screen to preserve a scroll
 * position nobody comes back to.
 */
export const publishersRoute: RouteRecordRaw = {
  path: '/publishers',
  name: 'Publishers',
  component: () => import('./pages/PublishersPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('st:core:publishers:list'),
  },
};

export const publisherRoute: RouteRecordRaw = {
  path: '/publishers/:id',
  name: 'Publisher',
  component: () => import('./pages/PublisherPage.vue'),
  props: true,
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('st:core:publishers:get'),
  },
};
